/* eslint-disable no-unused-vars */
import ttiPolyfill from 'tti-polyfill';

import { getExtendedLogger } from '../components/Logger';
import logger from '../config/app.logger';

const log = getExtendedLogger('tti', logger);

export const getTTIPromise = (maxDelay?: number) => {
  maxDelay = maxDelay || 10000;
  const tti = ttiPolyfill
    .getFirstConsistentlyInteractive({ useMutationObserver: false })
    .then(tti => log(`[TTI]: ${tti}`))
    .then(() => true);
  const race = new Promise(resolve => setTimeout(() => resolve(false), maxDelay));
  return Promise.race([tti, race]).then(fromTTI => {
    let msg = `[Race] Timeout won for maxDelay ${maxDelay}`;
    if (fromTTI) {
      msg = `[Race] TTI won for maxDelay ${maxDelay}`;
    }
    log(msg);
    return msg;
  });
};

export enum DELAYS {
  S = 3000,
  L = 10000,
  XL = 15000,
}

export const singletonTTIPromises = {
  [DELAYS.S]: getTTIPromise(DELAYS.S),
  [DELAYS.L]: getTTIPromise(DELAYS.L),
  [DELAYS.XL]: getTTIPromise(DELAYS.XL),
};
